import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ButtonItem from '../components/ButtonItem';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

function ArtistModifyPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const params = new URLSearchParams(location.search);
  const page = params.get('page');
  const search = params.get('search');
  const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
  const [artists, setArtists] = useState([]);
  const [imageUrlInput, setImageUrlInput] = useState(''); // 사용자가 입력한 URL
  const [image, setImage] = useState(
    'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
  ); // 실제 저장된 이미지 경로
  const [nameKr, setNameKr] = useState('');


  useEffect(() => {
    setImage(artists.image || '');
    setNameKr(artists.nameKr || '');
    setImageUrlInput(artists.image || '');
  }, [artists]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/artist/${id}`
        );
        setArtists(response.data);
      } catch (error) {
        console.error('서버 접속 에러:', error);
      }
    };
    fetchData();
  }, [id]);

  // 각 인풋 값 저장
  const imageValueChange = async (event) => {
    const url = event.target.value;
    setImageUrlInput(url);

    if (!url) {
      setImage(
        'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
      );
      return;
    }
    // 서버에 이미지 다운로드 요청
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/artist/imageDownload`,
        { url }
      );
      setImage(response.data.imagePath);
    } catch {
      setImage(
        'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
      );
    }
  };
  const nameKrValueChange = (event) => setNameKr(event.target.value);

  // 등록 버튼
  const add = async () => {
    // 입력값 검사
    if (!nameKr) {
      alert('모든 항목을 빠짐없이 입력해 주세요.');
      return;
    }
    // image가 비어있으면 기본 이미지로 설정
    const imageToSend =
      image && image.trim() !== ''
        ? image
        : 'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg';

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/artist/${id}`,
        {
          image: imageToSend,
          nameKr,
        },
        {
          headers: { 'Content-Type': 'application/json' },
        }
      );
      alert('아티스트 수정을 완료하였습니다.');
      navigate(`/Artists/${response.data.id}?page=${page}${searchParam}`);
    } catch (error) {
      alert('수정 중 오류가 발생했습니다.');
    }
  };

  return (
    <>
        <div className="flex mb-8 justify-center items-center">
          <div className="text-xl sm:text-2xl font-bold text-white tracking-tight">
            <span>아티스트 수정</span>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="w-[90%] max-w-[650px] space-y-6">
            {/* 프로필 이미지 Url */}
            <div>
              <label className="block font-semibold mb-1">
                프로필 이미지 Url
              </label>
              <input
                type="text"
                value={imageUrlInput}
                onChange={imageValueChange}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
                placeholder="이미지 URL을 입력하세요"
              />
              <img
                src={
                  image
                    ? image
                    : 'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
                }
                alt={nameKr}
                className="w-[200px] h-[200px] rounded-full object-cover mx-auto shadow mt-2"
                onError={(e) => {
                  e.target.onerror = null; // 무한루프 방지
                  e.target.src =
                    'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg';
                }}
              />
            </div>

            {/* 아티스트명 */}
            <div>
              <label className="block font-semibold mb-1">아티스트명</label>
              <input
                type="text"
                value={nameKr}
                onChange={nameKrValueChange}
                className="w-full px-3 py-2 rounded-xl border border-white/[0.08] bg-[#1a2b42] text-slate-200"
              />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-end items-center mt-5">
          <ButtonItem
            className="mr-2"
            text="목록"
            color="gray"
            onClick={() => navigate(`/Artists?page=${page}${searchParam}`)}
          />
          <ButtonItem
            className="mr-2"
            text="취소"
            color="red"
            onClick={() => navigate(`/Artists/${id}?page=${page}${searchParam}`)}
          />
          <ButtonItem text="등록" color="blue" onClick={add} />
        </div>
    </>
  );
}

export default ArtistModifyPage;
